import React from 'react';
import './LoadingOverlay.css';

const LoadingOverlay = ({ image, message }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-content">
        {image && <img src={image} alt="Loading" className="spinner-image" />}
        {message && <p>{message}</p>}
      </div>
    </div>
  );
};

export default LoadingOverlay;
